import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import DataTable, { TableStyles } from 'react-data-table-component';
import { Button } from '@app/components';
 import { getAllActiveFranchise } from '@app/services/franchise';
import Select from "react-select";
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { getAllLeadStatus, getProspectiveStudentsWithPagination } from '@app/services/lead';
import { getAllActiveSubjects } from '@app/services/subject';
import ProspectiveStudentDetailsModal from './ProspectiveStudentDetailsModal';
import ActivateSubjectModal from './ActivateSubjectModal';

const ListProspectiveStudent = () => {

    const canAccess = useSelector((state: any) => state.auth.permissions.lead);
    const navigate = useNavigate()
    const [t] = useTranslation()
    useEffect(() => {
        if(canAccess['ListProspectiveStudent'] == false){
            toast.error(t('auth.noAccess'))
            navigate('/')
        }
    }, [])
    const selectRef = useRef(null);
    const [leads, setLeads] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams()
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(searchParams.get('perPage') ?? 10);
    const [currentPage, setCurrentPage] = useState(searchParams.get('page') ?? 1);
    const [franchises, setFranchises] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [showAS, setShowAS] = useState(false);
    const handleCloseAS = () => setShowAS(false);
    const handleShowAS = () => setShowAS(true);
    const [modalASData, setModalASData] = useState({});
    const [modalData, setModalData] = useState({});
    const [leadStauses, setLeadStauses] = useState([]);

    const customStyle: TableStyles = {
        head: {
            style: {
                color: "#5E5873",
                fontSize: "13px",
                fontWeight: 900,
            },
        },
        headCells: {
            style: {
                borderColor: "#E9ECEF",
                textTransform: "uppercase",
                letterSpacing: "1px",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#F7F7F8",
                minHeight: "44px",
                fontWeight: 500,
            },
        },
    };

    const customStylesSelect = {
        dropdownIndicator: () => ({
            display: 'none',
        }),
    }

    useEffect(() => {
        getAllProspectiveStudents()
    },[searchParams]);

    useEffect(() => {
        getAllActiveFranchiseData()
        getAllActiveSubjectsAPI()
        getAllLeadStatusAPI()
    },[]);

    const getAllProspectiveStudents = async () => {
        try {
            setLoading(true);
            const resp = await getProspectiveStudentsWithPagination(searchParams);
            if (resp.success === true) {
                setLoading(false);
                setLeads(resp.collections.data);
                setTotalRows(resp?.collections?.pagination?.total);
            } else {
                setLoading(false);
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal Server Error')
        }
    };

    const getAllActiveFranchiseData = async () => {
        try {
            const resp = await getAllActiveFranchise();
            if (resp?.success === true) {
                setFranchises(resp?.collections);
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal Server Error')
        }
    };

    const getAllActiveSubjectsAPI = async () => {
        try {
            const resp = await getAllActiveSubjects()
            if (resp.success === true) {
                setSubjects(resp.collections);
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };

    const getAllLeadStatusAPI = async () => {
        try {
            const resp = await getAllLeadStatus()
            if (resp.success === true) {
                setLeadStauses(resp?.collections.filter((obj) => obj.id == 7 || obj.id == 8))
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };

    const columns = [
        {
            name: 'Franchise',
            selector: (row: { franchise_name: string; }) => row.franchise_name ? row.franchise_name : '---',
            sortable: true,
            sortField: 'franchise_name',
            wrap: true,
        },
        {
            name: 'Student',
            selector: (row: {student_name: string;}) => row.student_name,
            sortable: true,
            sortField: 'student_name',
            wrap: true,
        },
        {
            name: 'Parent',
            selector: (row: { parent_name: string;}) => row.parent_name,
            sortable: true,
            sortField: 'parent_name',
            wrap: true,
        },
        {
            name: 'Phone',
            selector: (row: { parent_phone: string; }) => row.parent_phone ? row.parent_phone : '---',
            sortable: false,
            sortField: 'parent_phone',
        },
        {
            name: 'Subject',
            selector: (row: { subject_name: string; }) => row.subject_name ? row.subject_name : '---',
            sortable: true,
            sortField: 'subject_name',
        },
        {
            name: 'Status',
            selector: (row: { status: string; }) => row.status,
            cell: (row: { status: string; }) => (
                row.status === 'Enrolled and Paid' ? <span className="uppercase badge bg-success">Enrolled and Paid</span> : (row.status === 'Lost' ? <span className="uppercase badge bg-danger">{row.status}</span> : <span className="uppercase badge bg-warning">{row.status}</span>)
            ),
            sortable: true,
            sortField: 'status',
            width: '16%',
        },
        {
            name: 'Updated On',
            selector: (row: { status_updated_date: string; }) => row.status_updated_date,
            cell: (row: { status_updated_date: string; }) => (
                row.status_updated_date ? moment(row.status_updated_date).format('DD/MM/YYYY') : '---'
            ),
            sortable: true,
            sortField: 'status_updated_date',
        },
        {  
            name: 'Action',
            cell: (row: { subject_name: string, lead_inquiry_student_subject_id: number, lead_inquiry_student_id: number, lead_inquiry_status_id: number}) => (
              <>
                <a href='javascript:void(0)' onClick={ (e) => { handleShowDetails(row)} }>
                    <i className="fas fa-eye mr-2" title="View Prospective Student Details"></i>
                </a>
                { canAccess['activate-student-subject'] &&
                    <a href='javascript:void(0)' onClick={ (e) => { handleActivateSubject(row)}} data-toggle="tooltip" title="Activate Student Subject">
                        <i className="fas fa-user-check"></i>
                    </a>
                }
              </>
            ),
            // minWidth: '14%'
        },
    ];

    const handlePageChange = page => {
        searchParams.set('page', page)
        setSearchParams(searchParams)
        
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        searchParams.set('perPage', newPerPage)
        setSearchParams(searchParams)
        
        setPerPage(newPerPage);
    };

    const handleSort = async (column, sortDirection) => {
        searchParams.set('sortField', column.sortField)
        searchParams.set('sortDirection', sortDirection)
        setSearchParams(searchParams)
    };

    const handleResetFilter = async () => {
        selectRef.current.setValue('');
        searchParams.delete('parentName')
        searchParams.delete('studentName')
        searchParams.delete('franchiseId')
        searchParams.delete('subjectId')
        searchParams.delete('leadStatusId')
        // searchParams.delete('dateOfInquiry')
        // searchParams.delete('updatedDate')
        setSearchParams(searchParams)  
    };

    const onChangeFranchise = (option) => {
        searchParams.set('franchiseId', option == null ? '' : option.id )
        setSearchParams(searchParams)
    };

    const handleShowDetails = async(obj) => {
        handleShow();
        setModalData(obj)
    }

    const handleActivateSubject = async(obj) => {
        handleShowAS();
        setModalASData(obj)
    }

    return (
        <div>
            {/* Content Header (Page header) */}
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>Prospective Students</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Prospective Students</li>
                            </ol>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
            </section>
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div style={{ marginBottom: 10 }} className="row">
                                
                            </div>
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Prospective Students</h3>
                                    <div className="col-lg-12 text-right">
                                        
                                    </div>
                                </div>
                                {/* /.card-header */}
                                <div className="card-body">
                                    <div className="row mb-2">
                                        <div className="col-sm-2">
                                            <label>Franchise</label>
                                            <Select
                                                ref={selectRef}
                                                name="franchiseId"
                                                placeholder="Search By Franchise"
                                                options={franchises}
                                                getOptionValue={(option)=>`${option['id']}`}
                                                getOptionLabel={(option)=>`${option['name']}`}
                                                onChange={ (option) => {onChangeFranchise(option)}}
                                                value={franchises.filter(function(option) {
                                                    return option.id == searchParams.get('franchiseId');
                                                })}
                                                isClearable={true}
                                                styles={customStylesSelect}
                                            />
                                        </div>
                                        <div className="col-sm-2">
                                            <label>Student Name</label>
                                            <input type="text" name='studentName' className="form-control" value={searchParams.get('studentName') ?? ''} onChange={(e) => {searchParams.set('studentName', e.target.value); setSearchParams(searchParams)}} placeholder="Search By Student Name" />
                                        </div>
                                        <div className="col-sm-2">
                                            <label>Parent Name</label>
                                            <input type="text" name='parentName' className="form-control" value={searchParams.get('parentName') ?? ''} onChange={(e) => {searchParams.set('parentName', e.target.value); setSearchParams(searchParams)}} placeholder="Search By Parent Name" />
                                        </div>
                                        <div className="col-sm-2">
                                            <label>Subject</label>
                                            <select
                                                className="form-control"
                                                name="subjectId"
                                                onChange={(e) => {  searchParams.set('subjectId', e.target.value); setSearchParams(searchParams)}}
                                                value={searchParams.get('subjectId') ?? ''}
                                            >
                                                <option value="">Search By Subject</option>
                                                {subjects.map((obj) => (
                                                    <option key={obj.id} value={obj.id}>
                                                        {obj.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-sm-2">
                                            <label>Lead Status</label>
                                            <select
                                                className="form-control"
                                                name="leadStatusId"
                                                onChange={(e) => {  searchParams.set('leadStatusId', e.target.value); setSearchParams(searchParams)}}
                                                value={searchParams.get('leadStatusId') ?? ''}
                                            >
                                                <option value="">Search By Status</option>
                                                {leadStauses.map((obj) => (
                                                    <option key={obj.id} value={obj.id}>
                                                        {obj.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className='col-sm-2' style={{marginTop: '32px'}}>
                                            <Button type="submit" isLoading={isLoading} onClick={handleResetFilter} className="btn btn-warning mr-2">Reset Filter</Button>
                                        </div>
                                    </div>

                                    <DataTable
                                        keyField='prospective-student'
                                        columns={columns}
                                        data={leads}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        paginationDefaultPage={Number(currentPage)}
                                        onChangePage={handlePageChange}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                        paginationPerPage={Number(perPage)}
                                        paginationRowsPerPageOptions={[5, 10, 20, 30, 50, 100]}
                                        progressPending={isLoading}
                                        sortServer
                                        onSort={handleSort}
                                        customStyles={customStyle}
                                    />
                                </div>
                                {/* /.card-body */}
                            </div>
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </div>
                {/* /.container-fluid */}
            </section>
            {/* /.content */}
            <ProspectiveStudentDetailsModal
                show={show}
                handleClose={handleClose}
                data={modalData}
            />

            <ActivateSubjectModal
                show={showAS}
                handleClose={handleCloseAS}
                payload={modalASData}
                getAllProspectiveStudents={getAllProspectiveStudents}
            />
        </div>
    )
};

export default ListProspectiveStudent;